import * as React from 'react';
import { connect } from 'react-redux';
import TransactionAmountOnePage from '../../components/transactions/TransactionAmountOnePage';
import TransactionAmountFailure from '~/apps/receiver/mobile/components/transactions/TransactionAmountFailure';
import TransactionAmountSuccess from '~/apps/receiver/mobile/components/transactions/TransactionAmountSuccess';
import { getPaycodeAttempList } from '~/apps/receiver/shared/actions/paycodes';
import { createPaycodeAttemp as postPaycodeAttemp } from '~/apps/receiver/shared/apis/paycodes';
import { defaultTablePageSize } from '~/common/components/consts';
import { navigate } from '~/router';

class Process {
  static readonly SUCCESS = 'success';
  static readonly FAILURE = 'failure';
  static readonly PROCESSING = 'processing';
}

class CreateTransactionOnePage extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.handleBackFailure = this.handleBackFailure.bind(this);
    this.handleBackHistory = this.handleBackHistory.bind(this);
    this.getDataForm = this.getDataForm.bind(this);

    this.state = {
      reg: {},
      process: Process.PROCESSING,
      errorMessage: '',
    };
  }

  onSubmit = (dataForm) => {
    const { dispatch, currentUser } = this.props;
    const locationId = currentUser.locationId;

    return postPaycodeAttemp(locationId, dataForm)
      .then((res) => {
        if (Object.prototype.hasOwnProperty.call(res, 'status')) {
          if (res.status === 'failure') {
            this.setState({
              process: Process.FAILURE,
              errorMessage: res.statusReason,
            })
          } else {
            dispatch(getPaycodeAttempList(0, defaultTablePageSize));
            this.setState({
              process: Process.SUCCESS,
              errorMessage: '',
              reg: {},
            })
          }
        } else {
          this.setState({
            process: Process.FAILURE,
            errorMessage: 'Request error',
          })
        }
      });
  };

  handleBackFailure() {
    this.setState({
      process: Process.PROCESSING,
      errorMessage: '',
    })
  };

  handleBackHistory() {
    navigate('receiver.mobile.history');
  };

  getDataForm(dataForm) {
    this.setState({
      reg: dataForm,
    })
  }

  render() {
    const { process, errorMessage, reg } = this.state;

    switch (process) {
      case Process.PROCESSING:
        return (
          <TransactionAmountOnePage
            initialValues={reg}
            getDataForm={this.getDataForm}
            onSubmit={this.onSubmit}
            onBack={this.handleBackHistory}
          />
        );
      case Process.FAILURE:
        return (
          <TransactionAmountFailure
            initialValues={reg}
            errorMessage={errorMessage}
            onBack={this.handleBackFailure}
          />
        );
      case Process.SUCCESS:
        return (
          <TransactionAmountSuccess
            onBack={this.handleBackHistory}
          />
        );
    }
  }
}


const mapStateToProps = (state) => {
  return {
    paymentAttempts: state.receiver.paycodeAttempts,
    currentUser: state.shared.auth.currentUser,
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateTransactionOnePage);
